<template>
  <div class="nft-page">
    <NftWrapper />
  </div>
</template>

<script>
import NftWrapper from '@/wrappers/NftWrapper.vue';

export default {
  name: 'NftPage',
  components: {
    NftWrapper,
  },
  data() {
    return {
      // Define your component data here
    };
  },
  methods: {
    // Add your methods here
  },
  computed: {
    // Add your computed properties here
  },
  mounted() {
    // Lifecycle hook for when the component is mounted
  },
};
</script>

<style scoped>
.nft-view {
  /* Add your styles here */
}
</style>